import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

if (typeof pdfjs !== 'undefined' && pdfjs.GlobalWorkerOptions) {
  pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
}

/**
 * 클레임 팝업 뷰어용 PDF 전용 영역 (react-pdf)
 */
export default function ClaimPdfViewer({ pdfSrc, fileName, regTime, toolbar }) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const onDocumentLoadSuccess = ({ numPages: pages }) => {
    setNumPages(pages);
    setPageNumber(1);
    setLoading(false);
  };
  const onDocumentLoadError = (e) => {
    setError(e?.message || 'PDF 로드 실패');
    setLoading(false);
  };

  return (
    <div style={{ display: 'block', minHeight: '70vh' }}>
      {toolbar}
      <ul className="font-bold my-4">
        <li>파일명 : {fileName}</li>
        <li>등록일시 : {regTime?.replace('T', ' ')}</li>
      </ul>
      {error ? (
        <div className="p-3 text-red-600">{error}</div>
      ) : (
        <>
          <div className="flex align-items-center justify-content-center gap-2 mb-2">
            <button
              type="button"
              className="p-button p-button-outlined p-button-sm"
              disabled={!numPages || pageNumber <= 1}
              onClick={() => setPageNumber((p) => Math.max(1, p - 1))}
            >
              이전
            </button>
            <span className="text-sm">
              {loading ? '로딩 중...' : `페이지 ${pageNumber} / ${numPages}`}
            </span>
            <button
              type="button"
              className="p-button p-button-outlined p-button-sm"
              disabled={!numPages || pageNumber >= numPages}
              onClick={() => setPageNumber((p) => Math.min(numPages, p + 1))}
            >
              다음
            </button>
          </div>
          <div className="flex justify-content-center overflow-auto">
            <Document
              file={pdfSrc}
              onLoadSuccess={onDocumentLoadSuccess}
              onLoadError={onDocumentLoadError}
              loading={null}
            >
              <Page
                pageNumber={pageNumber}
                width={Math.min(window.innerWidth * 0.85, 800)}
                renderTextLayer={true}
                renderAnnotationLayer={true}
              />
            </Document>
          </div>
        </>
      )}
    </div>
  );
}
